import { Roles } from "@/app/app.interface";
import { ROUTES } from "@/app/constants/routes_sidebar/routes.constant";
import { env } from "@/app/utils/env";
import { useAppSelector } from "@/redux/store";

export type RouteKey = keyof typeof ROUTES;
export type FeatureConfig = Partial<Record<RouteKey, boolean>> | "*";

const useGetEnvironmentFeature = (): FeatureConfig => {
  const userData = useAppSelector((state) => state.user?.userData);

  switch (env.DEPLOYMENT) {
    case "production":
    case "staging":
    case "development":
      return userData?.role === Roles.SUPER_ADMIN
        ? "*"
        : {
            ROOT: true,
            TABLE: true,
            PROJECT_REGISTER: true,
            ESTIMATES: true,
            TASK_CLAIMS: true,
            PROJECTS: true,
            WORKFORCE: true,
            ADMIN: true,
            MANAGER: true,
            EMPLOYEE: true,
            SUB_CONTRACTOR: true,
            WORKFORCE_SETTINGS: true,
            CUSTOMERS: true,
            CUSTOMER: true,
            CONTRACT_INVOICE: true,
            DOCKET_INVOICE: true,
            XERO_INVOICE: true,
            ACTIVITY: true,
            ITEMS: true,
            WORK_DOCKET: true,
            SETTINGS: true,
            PROJECT_DAILY_REPORTS: true,
            TIPPING_REPORT: true,
            DAILY_REPORTS: true,
            REPORT_QUESTIONS: true,
            REPORT_SETTINGS: true,
            SUMMARY: true,
            LOAD_TYPE: true,
            VEHICLES: true,
            TIPPING_YARD: true,
            WASTE_TYPE: true,
            WEIGHT_SCALE: true,
            TIME_SHEET: true,
            WASTE_SUMMARY_SETTINGS: true,
            APPROVAL: true,
            INDUCTION: true,
            MESSAGES: true,
            DOCUMENT_PARSER: true,
            INTELLIFLOW: true,
            ROSTER: true,
            REPORTS: true,
            USER_MANAGEMENT: true,
            WASTE_SUMMARY: true,
            WASTE_REQUEST: true,
            INVOICING: true,
            WARE_HOUSING: true,
          };
    default:
      return "*";
  }
};

export default useGetEnvironmentFeature;
